function providerInvoiceSetPaidDate(UserInfo, Alert, filtersUtils, DateUtils, ProviderInvoiceAPI){
    return {
        restrict: 'AE',
        templateUrl: require('../../templates/provider-invoices-set-paid-date.html'),
        controller: function ($scope, $rootScope, $filter) {
            /***********************************************************************************************************
            * Controller Attributes
            ***********************************************************************************************************/
            var $translate = $filter('translate');
            var self = this;

            /***********************************************************************************************************
            * Scope Attributes
            ***********************************************************************************************************/
            $scope.flagPaidDateConfirm = false;
            $scope.listToUpdate = [];
            $scope.paid_date = new Date;

            $scope.hasPerm = UserInfo.hasPerm('providers.change_set_provider_invoice_paid_date');

            /***********************************************************************************************************
            * Scope Watchers
            ***********************************************************************************************************/
            $scope.$on("selectedItemsChange", function (e, selectedItemsChange) {
                $scope.listToUpdate = selectedItemsChange;
            });

            $scope.$on("selectedCounterChange", function (e, selectedCounterChange) {
                $scope.counter = selectedCounterChange;
            });

            /***********************************************************************************************************
            * Controller Methods
            ***********************************************************************************************************/
            function performRequest(ids) {
                var date = DateUtils.transformToRESTyDate($scope.paid_date);
                var json = {ids: ids, paid_date: date};

                ProviderInvoiceAPI.setPaidDate(json).then(function (data) {
                    Alert.createAlert('success', $translate('PROVIDERS.PROVIDER_STATUS_UPDATED') + data.updated_paid_date, true);
                    $rootScope.$broadcast('refreshList');
                }).catch(function (error) {
                    $scope.error_message = error.data.__all__[0];
                }).finally(function () {
                    $scope.flagPaidDateConfirm = false;
                    $scope.listToUpdate = [];
                });
            }

            /***********************************************************************************************************
            * Scope Methods
            ***********************************************************************************************************/
            $scope.clickPaidDateYes = function () {
                var ids = filtersUtils.getItemsToDownloadToInt($scope.listToUpdate);
                performRequest(ids);
            };

            $scope.confirmPaidDate = function () {
                $scope.flagPaidDateConfirm = true;
            };

            $scope.clickPaidDateNo = function () {
                $scope.flagPaidDateConfirm = false;
            };

        }
    }
}

export { providerInvoiceSetPaidDate }
